module.exports = __webpack_public_path__ + "img/40.d1f9db9d.png";